import { BlockConfig, zeroIOPS, OperationTypes, ContentTypes } from "../block-base";
import { BlockTypes } from "../block-types";

export const networkLoadBalancerConfig: BlockConfig = {
  displayName: "Network Load Balancer",
  imagePath: "",
  isInitiator: true,
  isTerminator: true,
  isInterceptor: false,
  allowedInputTypes: new Set([
    BlockTypes.USER,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.LAMBDA,
    BlockTypes.APP_SERVER,
    BlockTypes.PASSTHROUGH,
  ]),
  allowedOutputTypes: new Set([
    BlockTypes.CACHE,
    BlockTypes.APP_SERVER,
    BlockTypes.DATABASE,
    BlockTypes.DB_READ_REPLICA,
    BlockTypes.GRAPH_DB,
    BlockTypes.DOCUMENT_DB,
    BlockTypes.S3_BUCKET,
    BlockTypes.PASSTHROUGH,
  ]),
  inputCapacity: {
    total: 225000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 135000,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 45000,
          [`${ContentTypes.STATIC}`]: 45000,
          [`${ContentTypes.STATIC_MEDIA}`]: 45000,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 90000,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 60000,
          [`${ContentTypes.STATIC_MEDIA}`]: 30000,
        },
      },
    },
  },
  processingCapacity: zeroIOPS(),
  purchasePrice: 75,
  sellPrice: 35,
  costPerCycle: 0.08,
  outputConnectorLimits: {},
};
